// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './TabBarStep1.css';

// Translation
import { injectIntl } from 'react-intl';

// Locale
import messages from '../../locale/messages';

import history from '../../core/history';
import { activeTabs } from '../../helpers/listingTabs';
import setTabActiveIndex from '../../actions/setTabActiveIndex';

// Component
class TabBarStep extends Component {
  static propTypes = {
    listingSteps: PropTypes.shape({
      step1: PropTypes.string,
      step2: PropTypes.string,
      step3: PropTypes.string,
    }),
    activeIndex: PropTypes.number,
    setTabActiveIndex: PropTypes.func.isRequired,
    nextPage: PropTypes.func,
    formPage: PropTypes.string,
    step: PropTypes.number,
    intl: PropTypes.object.isRequired,
  };

  static defaultProps = {
    arrow: true,
    listingSteps: {
      step1: 'inactive',
      step2: 'inactive',
      step3: 'inactive',
    },
    formPage: '',
    step: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      load: false,
      isClient: false,
    };
    this.onTabClick = this.onTabClick.bind(this);
  }

  componentDidMount() {
    this.setState({
      isClient: true,
      load: true,
    });
  }

  componentDidUpdate(prevProps) {
    const { locale } = this.props.intl || {};
    const { locale: prevLocale } = prevProps.intl || {};

    if (locale && prevLocale && locale !== prevLocale) {
      this.setState({ load: false });
      clearTimeout(this.loadSync);
      this.loadSync = setTimeout(() => {
        this.setState({ load: true });
      }, 3000);
    }
  }

  componentWillUnmount() {
    if (this.loadSync) clearTimeout(this.loadSync);
  }

  nextPage(formPage) {
    if (formPage) {
      history.push(formPage);
    }
  }

  onTabClick(index) {
    const { setTabActiveIndex } = this.props;
    if (setTabActiveIndex) setTabActiveIndex(index);
  }

  render() {
    const { formPage, step, listingSteps, activeIndex, intl } = this.props;
    const { formatMessage } = intl || {};
    const { load, isClient } = this.state;

    // Safety checks
    if (!formPage || !step || !listingSteps) {
      return null;
    }

    // Build tabs safely
    let tabBarData = [];
    try {
      const tabs = activeTabs(step, listingSteps);
      if (Array.isArray(tabs)) {
        tabBarData = tabs;
      }
    } catch (err) {
      console.error('activeTabs error:', err);
    }

    // Only render if we have valid data
    if (!load || !isClient || tabBarData.length === 0) {
      return null;
    }

    return (
      <div className="tabBarStepContainer">
        <div className="becomeHostTabsContainer">
          <div className={cx("becomeHostInnerBox becomeHostInnerBoxRtl", s.customTabsWrapper)}>
            {tabBarData.map((item, index) => {
              if (!item) return null;
              
              const isActive = item.activePaths
                ? item.activePaths.includes(formPage)
                : formPage === item.pathname;

              return (
                <div 
                  key={item.pathname || index}
                  className={s.customTabItem}
                >
                  <button
                    type="button"
                    onClick={() => {
                      this.onTabClick(index);
                      this.nextPage(item.pathname);
                    }}
                    className="tabButton"
                  >
                    <div
                      className={cx(
                        s.tabBorder,
                        { [s.active]: isActive },
                        'tabBorderRTL'
                      )}
                    >
                      {item.icon && (
                        <div className={s.iconBg}>
                          <img src={item.icon} alt="" />
                        </div>
                      )}
                      <span className={cx(s.tabFont, 'tabFontRTL')}>
                        {item.text
                          ? typeof item.text === 'object' && formatMessage
                            ? formatMessage(item.text)
                            : item.text
                          : ''}
                      </span>
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  listingSteps: state?.location?.listingSteps || {
    step1: 'inactive',
    step2: 'inactive',
    step3: 'inactive',
  },
  existingList: state?.location?.isExistingList || false,
  activeIndex: state?.calendar?.activeIndex || 0,
});

const mapDispatch = {
  setTabActiveIndex,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(TabBarStep))
);
